import React, { useEffect } from 'react';

function Hero() {
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      document.documentElement.style.setProperty('--scroll-y', `${scrolled}px`);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* ░░ HERO ░░ */}
      <section className="hero" id="hero">
        <div className="hero-grid"></div>
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>
        <div className="hero-blob blob3"></div>
        <div className="hero-chip"><span className="chip-dot"></span>Your Trust · Your Success· Our Priority</div>
        <h1 id="heroH1">
          <span className="word" style={{ animationDelay: '.15s' }}>Powering </span>{' '}
          <span className="word accent" style={{ animationDelay: '.22s' }}> Seamless </span>{' '}
          <span className="word accent" style={{ animationDelay: '.29s' }}> UPI </span><br />
          <span className="word" style={{ animationDelay: '.36s' }}>Transactions </span>{' '}
          <span className="word" style={{ animationDelay: '.43s' }}> with </span><br />
          <span className="word accent2" style={{ animationDelay: '.5s' }}>Unmatched </span>{' '}
          <span className="word accent2" style={{ animationDelay: '.57s' }}> Security.</span>
        </h1>
        <p className="hero-sub">India's fastest UPI switch — <strong style={{ color: 'rgba(255,255,255,.85)', fontWeight: '600' }}>99.99% uptime, &lt;50ms latency</strong>, and AI fraud detection that stops threats before they reach your customers.</p>
        <div className="hero-actions">
          <a className="btn-hero-cta btn-shimmer" href="https://speedvault.in/request_a_demo">Get a Free Demo →</a>
          <a className="btn-hero-outline" href="https://speedvault.in/get_a_quote">View Pricing</a>
        </div>
        <div className="hero-stats">
          <div className="hstat"><div className="hstat-num">10<span className="unit">M+</span></div><div className="hstat-label">Transactions/day</div></div>
          <div className="hstat"><div className="hstat-num">99<span className="unit">.99%</span></div><div className="hstat-label">Uptime SLA</div></div>
          <div className="hstat"><div className="hstat-num">&lt;50<span className="unit">ms</span></div><div className="hstat-label">Avg. latency</div></div>
          <div className="hstat"><div className="hstat-num">500<span className="unit">+</span></div><div className="hstat-label">Banks connected</div></div>
        </div>
      </section>
    </>
  );
}

export default Hero;
